<template>
  <BasePageContainer class="template-management">
    <SettingHeader>テンプレート管理</SettingHeader>
    <div class="pt-10 pb-11">
      <div class="template-management__item">
        <BaseButton
          color="secondary"
          data-testid="note-template-menu-button"
          @click="$router.push('/admin/note_templates/')">
          ノートテンプレートの作成
        </BaseButton>
        <p class="template-management__description">
          ノート作成時に呼び出して使うテンプレートを作成・管理します
        </p>
        <LabeledExternalLink
          label="テンプレート事例はこちら"
          :url="noteTemplateExampleUrl"
          data-testid="note-template-example-link" />
      </div>
      <div class="template-management__item">
        <BaseButton
          color="secondary"
          data-testid="mandala-goal-template-menu-button"
          @click="$router.push('/admin/mandala_goal_templates/')">
          目標テンプレートの作成
        </BaseButton>
        <p class="template-management__description">
          技術・メンタル・人間性など、目標作成時に呼び出して使うテンプレートを作成・管理します
        </p>
        <LabeledExternalLink
          label="目標設定事例はこちら"
          :url="mandalaGoalTemplateExampleUrl"
          data-testid="mandala-goal-template-example-link" />
      </div>
    </div>
  </BasePageContainer>
</template>

<script>
import SettingHeader from '@/components/parts/SettingHeader.vue'
import BaseButton from '@/components/parts/BaseButton.vue'
import LabeledExternalLink from '@/components/parts/LabeledExternalLink.vue'
import {
  NOTE_TEMPLATE_EXAMPLE_URL,
  MANDALA_GOAL_TEMPLATE_EXAMPLE_URL
} from '@/helper/templateExample'

export default {
  name: 'TemplateManagement',
  components: {
    SettingHeader,
    BaseButton,
    LabeledExternalLink
  },
  data() {
    return {
      noteTemplateExampleUrl: NOTE_TEMPLATE_EXAMPLE_URL,
      mandalaGoalTemplateExampleUrl: MANDALA_GOAL_TEMPLATE_EXAMPLE_URL
    }
  }
}
</script>

<style lang="scss" scoped>
.template-management {
  &__item {
    margin-bottom: 24px;
  }

  // 記録一覧トップの説明文と同じ大きさに揃える（先方指摘 2026-09-08）
  &__description {
    margin: 8px 0 0;
    font-size: $fs-nm;
    color: $black;
    line-height: 1.6;
  }
}
</style>
